// ============================================================
// types/asistencia.types.ts
// ============================================================

export type EstadoAsistencia = 'PRESENTE' | 'AUSENTE' | 'TARDANZA' | 'JUSTIFICADO';

// ── Etiquetas y colores por estado ────────────────────────────
export const ESTADO_LABEL: Record<EstadoAsistencia, string> = {
  PRESENTE:    'Presente',
  AUSENTE:     'Ausente',
  TARDANZA:    'Tardanza',
  JUSTIFICADO: 'Justificado',
};

export const ESTADO_COLOR: Record<EstadoAsistencia, string> = {
  PRESENTE:    'bg-green-100 text-green-700 border-green-200',
  AUSENTE:     'bg-red-100 text-red-700 border-red-200',
  TARDANZA:    'bg-amber-100 text-amber-700 border-amber-200',
  JUSTIFICADO: 'bg-blue-100 text-blue-700 border-blue-200',
};

export const ESTADO_DOT: Record<EstadoAsistencia, string> = {
  PRESENTE:    'bg-green-500',
  AUSENTE:     'bg-red-500',
  TARDANZA:    'bg-amber-500',
  JUSTIFICADO: 'bg-blue-500',
};

export const ESTADOS: EstadoAsistencia[] = ['PRESENTE', 'AUSENTE', 'TARDANZA', 'JUSTIFICADO'];

// ── Payloads ──────────────────────────────────────────────────

export interface AsistenciaItemPayload {
  matriculaId: number;
  estado:      EstadoAsistencia;
  motivo:      string | null;
}

export interface AsistenciaMasivoPayload {
  asignacionAcademicaId: number;
  fecha:                 string;   // YYYY-MM-DD
  registradoPorId:       number;
  asistencias:           AsistenciaItemPayload[];
}

export interface AsistenciaUpdatePayload {
  matriculaId:           number;
  asignacionAcademicaId: number;
  fecha:                 string;
  estado:                EstadoAsistencia;
  motivo:                string | null;
  registradoPorId:       number;
}

// ── Response del backend ──────────────────────────────────────
export interface AsistenciaResponse {
  idAsistencia:          number;
  matriculaId:           number;
  estudianteNombres:     string;
  estudianteApellidos:   string;
  estudianteDni:         string;
  asignacionAcademicaId: number;
  cursoNombre:           string;
  nivel:                 string;
  gradoNombre:           string;
  seccionNombre:         string;
  fecha:                 string;
  estado:                EstadoAsistencia;
  motivo:                string | null;
  registradoPorId:       number;
  registradoPorNombres:  string;
  fechaRegistro:         string;
  fechaActualizacion:    string | null;
}
